module.exports = __webpack_public_path__ + "static/honeymoon-351a0167053eb8bacb202086b6628405.png";